import React, { useState } from "react";
import classes from "./SmsComponent.module.css";
import FireboardUtils from "../../../../util/fireboard-util";
import PopupHeader from "../PopupHeader";
import classNames from "classnames";

const messages = [
  "Your [order type] order at [location] is now ready. Thank you.",
  "Your order from [location] is now on its way to [address].",
  "Your order at [location] for [pickup time] is waiting for you. Please contact the store at [phone] if you need assistance.",
  "Your contactless delivery has left [location] and should be there shortly.  Our driver will ring the doorbell at your address.",
  "Thank you for checking in! A Team Member will be out with your order shortly. Stay in your vehicle and call us if you haven't gotten your food in the next 5 minutes.",
  "Thank you for checking in! Your order is not quite ready yet, but a Team Member should be out to you shortly with an update.",
  "Can you please contact [location] about your order at [phone] ? Thank you.",
  "We have a question about your order at [location]. Please contact the store at [phone] as soon as you can.",
  "Your order at [location] is taking longer than expected. We apologize for the delay, please contact the store if you want to change your order.",
  "One of the items on your order from [location] is currently unavailable. Please contact the store at [phone] to select a different item. Thank you.",
  "We are having trouble locating [address]. Please contact the store as soon as possible at [phone] so we can deliver your order.",
];

const SmsRow = ({ sms, storeInfo, onHandleSend, selectedItem, iso2, smsIndex }) => {
  const [selectedAction, setSelectedAction] = useState(-1);

  const getSourceTypeFromOrderType = (type) => {
    switch (type) {
      case 5:
        return "curbside";
      case 6:
        return "online";
      case 8:
        return "call in";
      case 7:
        return "walkup";
      default:
        break;
    }
  };

  const dataObj = {
    address: selectedItem.checkInNote,
    phone: FireboardUtils.formattedPhoneNumber(storeInfo.phoneNumber, iso2),
    "pickup time": FireboardUtils.getTimeInHrsMins(selectedItem.pickupDate),
    location: storeInfo.name,
    "order type": getSourceTypeFromOrderType(selectedItem.sourceType),
  };

  let formatMessage = sms;
  Object.keys(dataObj).forEach((key) => {
    if (key === "address") {
      if (
        formatMessage.includes(
          "Your order from [location] is now on its way to"
        )
      ) {
        const address = dataObj[key] || "";
        const replaceableText = !!address ? `[${key}]` : `to [${key}]`;
        formatMessage = formatMessage.replace(replaceableText, address);
      } else {
        formatMessage = formatMessage.replace(
          `[${key}]`,
          dataObj[key] || "your address"
        );
      }
    } else {
      formatMessage = formatMessage.replace(`[${key}]`, dataObj[key] || "");
    }
  });

  return (
    <div className={classNames({ [classes.smsView]: true, [classes.highligthtedAction]: selectedAction === smsIndex })}
      onMouseEnter={() => setSelectedAction(smsIndex)}
      onMouseLeave={() => setSelectedAction(-1)}
    >
      <span className={classes.smsViewText} onClick={() => onHandleSend(formatMessage)}>{formatMessage}</span>
    </div>
  );
};

const SmsComponent = ({ selectedItem, onHandleSend, storeInfo, onClose, iso2 }) => {
  return (
    <>
      <PopupHeader title={''} onClose={onClose} containerStyle={classes.heading} />
      <div className={classes.container}>
        {Array.isArray(messages) &&
          messages.length &&
          messages.map((message, messageIndex) => {
            return (
              <SmsRow
                key={messageIndex}
                sms={message}
                storeInfo={storeInfo}
                onHandleSend={onHandleSend}
                selectedItem={selectedItem}
                iso2={iso2}
                smsIndex={messageIndex}
              />
            );
          })}
      </div>
    </>
  );
};

export default SmsComponent;
